import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'searchHighlight' })
export class HighlightSearchPipe implements PipeTransform {
  transform(text: string, match?: string): string {
    if (!text || !match) {
      return text;
    }

    const regex = new RegExp(match, 'gi');
    return text.replace(regex, `<span class="highlight">$&</span>`);

  }
}

